export * from './BedroomIcon'
